import Bugsnag, { OnErrorCallback } from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'
import { APP_VERSION } from './version'

const bugsnagClient = Bugsnag.start({
  apiKey: '1c1874ad6eac2d22bd1df70f3fb19e7a',
  plugins: [new BugsnagPluginReact(React)],
  releaseStage: import.meta.env.VITE_NODE_ENV,
  appVersion: APP_VERSION,
});

export const bugsnagNotify = (e: unknown, onError?: OnErrorCallback) => {
  if (e instanceof Error) {
    bugsnagClient.notify(e, onError);
  } else {
    bugsnagClient.notify(new Error(`Non-Error thrown: ${JSON.stringify(e)}`), onError);
  }
}

export default bugsnagClient;
